module.exports = __webpack_public_path__ + "static/media/lou_garcia.ff2644a8.png";